import React from 'react';
import { FormattedMessage } from 'react-intl';

import {
  SideNavigation,
  SideNavigationItem,
} from '../../components/SideNavigation';

const ContactsMenu = React.memo(() => (
  <SideNavigation>
    <SideNavigationItem isDefault to="/contacts">
      <FormattedMessage id="contacts.title" defaultMessage="Contacts" />
    </SideNavigationItem>
  </SideNavigation>
));

ContactsMenu.displayName = 'ContactsMenu';

export { ContactsMenu };
